import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../common/Button'

interface FlashcardGenerationNotificationProps {
  count: number
  onClose: () => void
}

export function FlashcardGenerationNotification({
  count,
  onClose,
}: FlashcardGenerationNotificationProps) {
  const navigate = useNavigate()

  const handleViewFlashcards = () => {
    onClose()
    navigate('/flashcards')
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 animate-slide-up">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-6 max-w-md">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-success-100 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-success-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>

          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              Flashcards Generated!
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              {count} {count === 1 ? 'flashcard' : 'flashcards'} created from your
              conversation.
            </p>

            <div className="flex space-x-3">
              <Button onClick={handleViewFlashcards} variant="primary" size="sm">
                View Flashcards
              </Button>
              <Button onClick={onClose} variant="outline" size="sm">
                Dismiss
              </Button>
            </div>
          </div>

          <button
            onClick={onClose}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
